import { render, staticRenderFns } from "./ReviewUpLimitProgress.vue?vue&type=template&id=54b8fc8f&scoped=true"
import script from "./ReviewUpLimitProgress.vue?vue&type=script&lang=js"
export * from "./ReviewUpLimitProgress.vue?vue&type=script&lang=js"
import style0 from "./ReviewUpLimitProgress.vue?vue&type=style&index=0&id=54b8fc8f&prod&lang=css"
import style1 from "./ReviewUpLimitProgress.vue?vue&type=style&index=1&id=54b8fc8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b8fc8f",
  null
  
)

export default component.exports